module.exports = __webpack_public_path__ + "media/images/index/care_01-3e03e319247ed5cabd3f96c41cfacee1.jpg";